const lang = document.documentElement.lang

const lc = (field) => lang ? `page.content("${lang}").${field}` : `page.${field}`
const sc = (field) => lang ? `site.content("${lang}").${field}` : `site.${field}`

const Images = {
  query: 'page.images',
  select: {
    id: true,
    filename: true,
    url: true,
    width: 'file.width()',
    height: 'file.height()',
    ratio: 'file.ratio()',
    srcset: 'file.srcset([300, 600, 900, 1200, 1800, 2200])',
    alt: 'file.alt',
  }
}

const Files = {
  query: 'page.files',
  select: { id: true, filename: true, url: true }
}

const Base = {
  title: lang ? `page.content("${lang}").title` : true,
  url: lang ? `page.url("${lang}")` : true,
  fiurl: 'page.url("fi")',
  enurl: 'page.url("en")',
  uid: true,
  id: true,
  template: 'page.intendedTemplate()',
  listed: 'page.isListed',
  images: Images,
}

const For = {}

const ProductionFields = {
  tagline:      lang ? `page.content("${lang}").tagline`      : 'page.tagline',
  datestart:    lang ? `page.content("${lang}").datestart`    : 'page.datestart',
  dateend:      lang ? `page.content("${lang}").dateend`      : 'page.dateend',
  performances: lang ? `page.content("${lang}").performances` : 'page.performances',
}

For.Children = {
  ...Base,
  children: {
    query: 'page.childrenAndDrafts',
    select: { ...Base, ...ProductionFields }
  }
}

For.Default = {
  ...Base,
  tagline: lang ? `page.content("${lang}").tagline` : true,
  layout: lang ? `page.content("${lang}").layout` : true,
  files: Files,
}

For.Home = {
  ...For.Default,
}

For.Article = {
  ...For.Default,
  date:     lang ? `page.content("${lang}").date`     : 'page.content.date',
  category: lang ? `page.content("${lang}").category` : 'page.content.category',
}

For.Production = {
  ...For.Default,
  ...ProductionFields,
  number: lang ? `page.content("${lang}").number` : 'page.content.number',
}

For.Site = {
  title:      lang ? `site.content("${lang}").title`   : 'site.title',
  tagline:    lang ? `site.content("${lang}").tagline` : 'site.tagline',
  footer:     lang ? `site.content("${lang}").footer`  : 'site.footer',
  navigation: 'site.navigation',
  facebook:   'site.facebook',
  instagram:  'site.instagram',
  images: {
    query: 'site.images',
    select: {
      id: true, filename: true, url: true,
      width: 'file.width()', height: 'file.height()',
      srcset: 'file.srcset([300, 600, 900, 1200, 1800, 2200])',
    }
  }
}

export default { For }
